
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"30","fill":"#1434CB","rx":"2"}}),_c('path',{attrs:{"fill":"#fff","d":"M19.428 9.212 14.453 20.82h-3.246L8.76 11.556c-.149-.57-.278-.78-.73-1.02-.738-.391-1.957-.759-3.029-.987l.073-.337h5.225c.666 0 1.264.434 1.415 1.184l1.294 6.715 3.195-7.9h3.226zm12.718 7.817c.013-3.063-4.332-3.232-4.302-4.6.009-.417.415-.86 1.302-.973.44-.056 1.652-.099 3.027.52l.54-2.461A8.4 8.4 0 0 0 29.84 9c-3.035 0-5.17 1.578-5.189 3.837-.02 1.67 1.525 2.603 2.688 3.158 1.197.569 1.599.934 1.594 1.443-.008.778-.954 1.122-1.838 1.135-1.544.024-2.44-.408-3.153-.733l-.557 2.543c.718.322 2.042.603 3.415.617 3.226 0 5.336-1.558 5.346-3.97Zm8.014 3.79H43L40.521 9.212H37.9c-.59 0-1.087.336-1.307.852l-4.607 10.755h3.224l.64-1.734h3.94zm-3.426-4.113 1.616-4.358.93 4.358zM23.815 9.212 21.276 20.82h-3.07l2.54-11.607h3.07Z"}})])
          )
        }
      }
    